import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {AuthenticationService} from '../authentication.service';

/**
 * Guard for the public part of the app - it never blocks navigation.
 *
 * It only does the session housekeeping AuthGuard does: picks up a session started in another
 * SSO app from the shared cookie, drops one that has expired or was ended elsewhere, and keeps
 * the token fresh. Without it a user already logged in would look anonymous until they open
 * a guarded page.
 */
@Injectable()
export class SessionGuard implements CanActivate {
    constructor(
        private authenticationService: AuthenticationService,
    ) {
    }

    canActivate(): boolean {
        if (this.authenticationService.checkForUserCookie()) {
            this.authenticationService.checkTokenRefreshRequirement();
        }

        return true;
    }
}
